"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HmoRecordHmoManager$ = exports.HmoRecordHmoManager$outboundSchema = exports.HmoRecordHmoManager$inboundSchema = void 0;
exports.hmoRecordHmoManagerToJSON = hmoRecordHmoManagerToJSON;
exports.hmoRecordHmoManagerFromJSON = hmoRecordHmoManagerFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.HmoRecordHmoManager$inboundSchema = z.object({
    manager_address: z.nullable(z.string()),
    manager_name: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "manager_address": "managerAddress",
        "manager_name": "managerName",
    });
});
/** @internal */
exports.HmoRecordHmoManager$outboundSchema = z.object({
    managerAddress: z.nullable(z.string()),
    managerName: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        managerAddress: "manager_address",
        managerName: "manager_name",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var HmoRecordHmoManager$;
(function (HmoRecordHmoManager$) {
    /** @deprecated use `HmoRecordHmoManager$inboundSchema` instead. */
    HmoRecordHmoManager$.inboundSchema = exports.HmoRecordHmoManager$inboundSchema;
    /** @deprecated use `HmoRecordHmoManager$outboundSchema` instead. */
    HmoRecordHmoManager$.outboundSchema = exports.HmoRecordHmoManager$outboundSchema;
})(HmoRecordHmoManager$ || (exports.HmoRecordHmoManager$ = HmoRecordHmoManager$ = {}));
function hmoRecordHmoManagerToJSON(hmoRecordHmoManager) {
    return JSON.stringify(exports.HmoRecordHmoManager$outboundSchema.parse(hmoRecordHmoManager));
}
function hmoRecordHmoManagerFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.HmoRecordHmoManager$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'HmoRecordHmoManager' from JSON`);
}
//# sourceMappingURL=hmorecordhmomanager.js.map